import type { FacesheetAnchorRef, FacesheetHtmlSummaryData } from '../types';
import { FacesheetDemographicsCard } from './FacesheetDemographicsCard';
import {
  FacesheetCriteriaSection,
  type FacesheetCriteriaSectionProps,
} from './FacesheetCriteriaSection';

export interface FacesheetSummaryViewProps {
  summary: FacesheetHtmlSummaryData;
  getAnchorRef: FacesheetAnchorRef;
  onOpenReferences: FacesheetCriteriaSectionProps['onOpenReferences'];
}

export const FacesheetSummaryView = ({
  summary,
  getAnchorRef,
  onOpenReferences,
}: FacesheetSummaryViewProps) => {
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-6">
      <FacesheetDemographicsCard
        data={summary.demographics}
        anchorRef={getAnchorRef('section-demographics')}
      />
      {summary.criteriaSections.map((section) => (
        <FacesheetCriteriaSection
          key={section.id}
          title={section.title}
          sectionId={section.anchorId}
          section={section.id}
          rows={section.rows}
          sectionRef={getAnchorRef(section.anchorId)}
          getAnchorRef={getAnchorRef}
          onOpenReferences={onOpenReferences}
        />
      ))}
    </div>
  );
};
